
import React from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown'
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/cjs/styles/hljs'
import { Grid, TextField } from "@mui/material";
import rehypeRaw from "rehype-raw"

interface ToggleProps {
  toggle: [boolean, React.Dispatch<React.SetStateAction<boolean>>],
  markDownData: [string, React.Dispatch<React.SetStateAction<string>>],
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function MarkDownEditor(props: ToggleProps) {

  const [open, setOpen] = props.toggle
  const [markDownData, setMarkDownData] = props.markDownData
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>

      <Dialog open={open} onClose={handleClose} fullWidth={true} fullScreen TransitionComponent={Transition}>
        <DialogTitle>Edit MarkDown</DialogTitle>
        <DialogContent>

          <Grid container justifyContent={"center"} spacing={1} >

            <Grid item xl={6} md={6} sm={6} xs={6} >
              <TextField
                color="secondary"
                autoFocus
                margin="dense"
                id="description"
                multiline
                value={markDownData}
                type="text"
                fullWidth
                onChange={(e) => setMarkDownData(e.target.value)}
              />
            </Grid>

            <Grid item xl={6} md={6} sm={6} xs={6} >
              <ReactMarkdown rehypePlugins={[rehypeRaw]} components={{
                code({ node, inline, className, children, ...props }) {
                  const match = /language-(\w+)/.exec(className || '')
                  return !inline && match ? <Component value={String(children).replace(/\n$/, '')} language={match[1]}></Component> : (
                    <code className={className} {...props}>
                      {children}
                    </code>
                  )
                }
              }}>
                {markDownData}
              </ReactMarkdown>
            </Grid>
          </Grid>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}


interface highlighterProps {
  value: string,
  language: string
}

const Component = (props: highlighterProps) => {
  return (
    <SyntaxHighlighter language={props.language} style={docco} >
      {props.value}
    </SyntaxHighlighter>
  );
};
